<template>
  <!-- 某課程的紀錄清單 -->
  <div class="page counseling-record-page">
    <f7-navbar :title="courseName" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <!-- Extended FAB Center Bottom -->
    <template v-if="coachType==10">
      <div class="fab fab-center-bottom fab-extended-button">
        <a @click="checkHrefEdit('record-edit')">
          <i class="icon material-icons md-only">add</i>
          <div class="fab-text">新增紀錄</div>
        </a>
      </div>
    </template>

    <div class="page-content">
      <header>
        <div class="course-content">
          <f7-row>
            <div class="avatar"></div>
            <div class="name">
              <h3>{{ $store.state.userInfo.chineseName }}</h3>
              <!--
              <p>
                <span>選課代碼 21004</span>
                <span>・</span>
                <span>課程代號 1131</span>
              </p>
              -->
            </div>
          </f7-row>
        </div>
      </header>

      <div class="wave-header sticky-tabbar" v-if="!loadingFlag">
        <f7-toolbar tabbar scrollable position="top">
          <f7-link
            v-for="(tab, index) in tabs"
            :key="tab"
            :tab-link="`#tab-${tab}`"
            :tab-link-active="index == activeIndex "
          >{{tab}}</f7-link>
        </f7-toolbar>
      </div>

      <f7-tabs v-if="!loadingFlag" class="counseling-record-list-wrap">
        <f7-tab
          v-for="(tab, index) in tabs"
          :key="tab"
          :id="`tab-${tab}`"
          :tab-active="index == activeIndex"
        >
          <!-- 無資料時 --
          <div class="page-empty">
            <img src="../../../images/background-img/study-grey.png" alt />
            <h3>目前尚無任何紀錄</h3>
            <p>請老師新增紀錄以取得 T 幣</p>
          </div> 
          -->

          <template v-for="(item,item_index) in feedbackList">
            <template v-if="coachType==10 ">
              <template v-if="index ==0 && item.status == 10">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                         class="image-cover" v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' +item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <p class="sub-content">
                        <span>{{ item.classAt.toString().split("T")[0] }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                      </p>
                      <p class="rating-hint">等待評分中</p>
                    </f7-card-content>
                  </a>
                </f7-card>
              </template>

              <template v-if="index ==1 && item.status == 30">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        class="image-cover" style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                        v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' + item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <p class="sub-content">
                        <span>{{ item.classAt.toString().split("T")[0] }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                      </p>
                      <p class="rating-hint">已完成評分</p>

                      <div class="rating-wrap">
                        <div class="range-bar">
                          <!-- 比如 value: 3.5 -->
                          <!-- style= width: 3.5*20% -->
                          <div class="range-bar-active" v-bind:style="{'width': item.feedbackScore*20 +'%'}"></div>
                        </div>
                      </div>

                    </f7-card-content>
                  </a>
                </f7-card>
              </template>
              <template v-if="index ==2 && item.status == 60">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                        class="image-cover" v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' + item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <p class="sub-content">
                        <span>{{ item.classAt.toString().split("T")[0] }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                        <!--
                          <span>08:00</span>
                          <span class="hours">3 hrs</span>
                        -->
                      </p>

                      <p class="rating-hint">已完成評分</p>
                      <div class="rating-wrap">
                        <div class="range-bar">
                          <!-- 比如 value: 3.5 -->
                          <!-- style= width: 3.5*20% -->
                          <div class="range-bar-active" v-bind:style="{'width': item.feedbackScore*20 +'%'}"></div>
                        </div>
                      </div>
                    </f7-card-content>
                  </a>
                </f7-card>
              </template>
              <template v-if="index ==3 && item.status == 80">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                       class="image-cover" v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' + item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <p class="sub-content">
                        <span>{{ item.classAt.toString().split("T")[0] }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                      </p>
                      <p class="rating-hint">已完成評分</p>
                      <div class="rating-wrap">
                        <div class="range-bar">
                          <!-- 比如 value: 3.5 -->
                          <!-- style= width: 3.5*20% -->
                          <div class="range-bar-active" v-bind:style="{'width': item.feedbackScore*20 +'%'}"></div>
                        </div>
                      </div>
                    </f7-card-content>
                  </a>
                </f7-card>
              </template>
            </template>

            <template v-else-if="coachType==20">
              <template v-if="index==0 && item.status==10">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                        class="image-cover" v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' + item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <p class="sub-content">
                        <span>{{ item.classAt.toString().split("T")[0] }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                        <!--
                          <span>08:00</span>
                          <span class="hours">3 hrs</span>
                        -->
                      </p>
                      <p class="rating-hint">為此次輔導評分</p>
                    </f7-card-content>
                  </a>
                </f7-card>
              </template>
              <template v-if="index==1 && item.status==30">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                        class="image-cover" v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' + item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <div class="sub-content">
                        <span>{{ item.classAt.toString().split("T")[0] }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                        <!--
                          <span>08:00</span>
                          <span class="hours">3 hrs</span>
                        -->
                        <div class="rating-wrap">
                          <div class="range-bar">
                            <!-- 比如 value: 3.5 -->
                            <!-- style= width: 3.5*20% -->
                            <div class="range-bar-active" v-bind:style="{'width': item.feedbackScore*20 +'%'}"></div>
                          </div>
                        </div>
                      </div>
                    </f7-card-content>
                  </a>
                </f7-card>
              </template>
              <template v-if="index==2 && item.status==60">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                        class="image-cover" v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' + item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <div class="sub-content">
                        <span>{{ item.classAt }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                        <!--
                          <span>08:00</span>
                          <span class="hours">3 hrs</span>
                        -->
                        <div class="rating-wrap">
                          <div class="range-bar">
                            <!-- 比如 value: 3.5 -->
                            <!-- style= width: 3.5*20% -->
                            <div class="range-bar-active" v-bind:style="{'width': item.feedbackScore*20 +'%'}"></div>
                          </div>
                        </div>
                      </div>
                    </f7-card-content>
                  </a>
                </f7-card>
              </template>
              <template v-if="index==3 && item.status==80">
                <f7-card class="card-outline">
                  <a @click="checkHref(item.id,item.courseName,item.updatedAt,item.classHours,item.feedbackScore,item.feedbackNote,item.classImagePath,item.status)">
                    <template v-if="item.classImagePath==''">
                      <f7-card-header
                        style="background-image:url(https://image.freepik.com/free-photo/group-diverse-senior-adults-computer-class_53876-30124.jpg)"
                      ></f7-card-header>
                    </template>
                    <template v-else>
                      <f7-card-header
                        class="image-cover" v-bind:style="{'background-image':'url('+$app.cdnUrl +'/' + item.classImagePath+')'}"
                      ></f7-card-header>
                    </template>
                    <f7-card-content>
                      <div class="sub-content">
                        <span>{{ item.classAt }}</span>
                        <span class="hours">{{ item.classHours }} hrs</span>
                        <!--
                          <span>08:00</span>
                          <span class="hours">3 hrs</span>
                        -->
                        <div class="rating-wrap">
                          <div class="range-bar">
                            <!-- 比如 value: 3.5 -->
                            <!-- style= width: 3.5*20% -->
                            <div class="range-bar-active" v-bind:style="{'width': item.feedbackScore*20 +'%'}"></div>
                          </div>
                        </div>
                      </div>
                    </f7-card-content>
                  </a>
                </f7-card>
              </template>
            </template>
          </template>
          <template v-if="applyingFlag == false && index ==0">
            <div class="page-empty">
              <img src="../../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
              <template v-if="coachType==10">
                <p>請老師新增紀錄以取得 T 幣</p>
              </template>
            </div>
          </template>
          <template v-if="checkingFlag == false && index ==1">
            <div class="page-empty">
              <img src="../../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
              <template v-if="coachType==10">
                <p>請老師新增紀錄以取得 T 幣</p>
              </template>
            </div>
          </template>
          <template v-if="acceptFlag == false && index ==2">
            <div class="page-empty">
              <img src="../../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
              <template v-if="coachType==10">
                <p>請老師新增紀錄以取得 T 幣</p>
              </template>
            </div>
          </template>
          <template v-if="nonAcceptFlag == false && index ==3">
            <div class="page-empty">
              <img src="../../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
              <template v-if="coachType==10">
                <p>請老師新增紀錄以取得 T 幣</p>
              </template>
            </div>
          </template>
        </f7-tab>
      </f7-tabs>
    </div>
  </div>
</template>

<script>
import Service from "../../../service";
import axios from "../../../js/axiosModule.js";
import { bus } from "../../../js/bus";
var moment = require('moment');
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      tabs: ["申請中", "審核中", "審核通過", "審核不過"],
      isBottom: true,
      coachType: this.$store.state.coachType,
      name: "",
      courseCode: "",
      courseName: "",
      updatedAt: "",
      updatedBy: "",
      studentno: "",
      classHours: "",
      id: "",
      applyStatus: "",
      courseEndAt: "",
      loadingFlag: false,
      activeIndex: 0,
      feedbackScore: this.$store.state.feedbackScore,
      feedbackNote: "",
      classImagePath: "",
      applyingFlag: false,
      checkingFlag: false,
      acceptFlag: false,
      nonAcceptFlag: false,
      feedbackList: []
    };
  },
  created: function() {
    let self = this;
    bus.$on("record-bus", function(res) {
      //console.log(res);
      self.loadingFlag = true;
      self.name = res.chineseName;
      self.courseCode = res.courseCode;
      self.courseName = res.courseName;
      self.updatedAt = res.updatedAt;
      self.updateBy = res.updatedBy;
      self.classImagePath = res.classImagePath;
      self.studentno = res.studentno;
      self.id = res.id;
      self.classHours = res.classHours;
      self.applyStatus = res.applyStatus;
      self.courseEndAt = res.courseEndAt;
      self.loadingFlag = false;
      self.feedbackNote = res.feedbackNote;
      if (self.applyStatus == 10) {
        self.activeIndex = 0;
      } else if (self.applyStatus == 30) {
        self.activeIndex = 1;
      } else if (self.applyStatus == 60) {
        self.activeIndex = 2;
      } else if (self.applyStatus == 80) {
        self.activeIndex = 3;
      }
      self.initScore();
    });
  },
  methods: {
    checkHref: function(
      id,
      courseName,
      updatedAt,
      classHours,
      feedbackScore,
      feedbackNote,
      classImagePath,
      status
    ) {
      let self = this;

      window.localStorage.removeItem("courseCodeStr");
      window.localStorage.setItem("courseCodeStr", self.id);
      self.$store.dispatch("feedBackSocreTrigger", feedbackScore);
      return new Promise((resolve, reject) => {
        this.$f7router.navigate("/counseling-record/counseling-rating");
        setTimeout(function() {
          bus.$emit("rating-bus", {
            id: id,
            classImagePath: classImagePath,
            classHours: classHours,
            applyStatus: self.applyStatus,
            chineseName: self.name,
            courseName: courseName,
            updatedAt: updatedAt,
            updatedBy: self.updatedBy,
            studentno: self.studentno,
            courseEndAt: self.courseEndAt,
            feedbackScore: feedbackScore,
            feedbackNote: feedbackNote,
            status : status
          });
        }, 100);
      });
    },
    getNowTime: function() {
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time, "YYYY-MM-DD HH:mm:ss")._d; 
      return dateTime;
    },
    getHalfTime: function() {
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss").month(1)._d; 
      return dateTime;
    },
    initScore: function() {
      let self = this;
      self.loadingFlag = true;
      var params = {};

      params.queryType = "courseid";
      params.queryString = self.id.toString();
      params.minStatus = 10;
      params.maxStatus = 80;
      params.takeRowCount = 0;
      params.startAt = self.getHalfTime();
      params.endAt = self.getNowTime();
      axios
        .axiosTokenPost(
          self.$app.axiosUrl + "/api/Coach/GetCoachClassRecords",
          params
        )
        .then(response => {
          //   console.log(response);
          if (response.data.data.length > 0) {
            self.feedbackList = response.data.data;
            response.data.data.forEach(function(item, index, array) {
              if (item.status == 10) {
                self.applyingFlag = true;
              } else if (item.status == 30) {
                self.checkingFlag = true;
              } else if (item.status == 60) {
                self.acceptFlag = true;
              } else if (item.status == 80) {
                self.nonAcceptFlag = true;
              }
            });
          }

          self.loadingFlag = false;
        })
        .catch(
          err =>
            function() {
              if (
                self.$store.state.userInfo === undefined ||
                self.$store.state.userInfo === null
              ) {
                self.$f7router.navigate("/login");
              }
            }
        );
    },
    checkHrefEdit: function() {
      this.$f7router.navigate("/record-edit");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling/counseling-record.vue